import { Route, Routes } from "react-router-dom";
import { featureIndex, pageIndex } from "./LazyImports";
import ErrorScreen from "@common/components/ErrorScreen";
import { useProjectDataStore } from "@state/projectDataStore";
import { info2Data } from "@common/features/Info2/info2Data";
import { theLocationData } from "@common/features/TheLocation/theLocationData";
import TubeConnections from "@layouts/sidebar-layout/pages/Tube";

const PageBuilder = () => {
  const {
    navigationData,
    galleryData,
    residencesData,
    orbitData,
    mapData,
    favouritesData,
    explorerData,
    sharedOwnershipData,
    aboutData,
    info1Data,
    developmentData,
  } = useProjectDataStore((s) => ({
    navigationData: s.navigationData,
    splashData: s.splashData,
    galleryData: s.galleryData,
    residencesData: s.residencesData,
    orbitData: s.orbitData,
    mapData: s.mapData,
    favouritesData: s.favouritesData,
    explorerData: s.explorerData,
    sharedOwnershipData: s.sharedOwnershipData,
    aboutData: s.aboutData,
    info1Data: s.info1Data,
    developmentData: s.developmentData,
  }))

  const pageDataMap = {
    gallery: galleryData,
    residences: residencesData,
    map: mapData,
    favourites: favouritesData,
    explorer: explorerData,
    orbits: orbitData,
    sharedOwnership: sharedOwnershipData,
    about: aboutData,
    info1: info1Data,
    info2: info2Data, // Just to use some data. This can be deleted. It is for the story page which can can its data in a json as it wont be on platform.
    theLocationData: theLocationData,
    development: developmentData,
  }

  const SplashPage = pageIndex[`${navigationData?.layout}-splash`]

  const menuItems = navigationData?.menuItems
    ? [
        {
          id: "123",
          include: "true",
          navLabel: "Trillium",
          pageType: "the-location",
        },
        {
          id: "6718c699b5c2c70026898852",
          include: "true",
          navLabel: "Story",
          pageType: "info2",
        },
        ...navigationData.menuItems,
        {
          include: "true",
          navLabel: "Media",
          pageType: "development",
          id: "671b63238844e00026fe8c29",
        },
      ]
    : []

  return (
    <Routes>
      {/* Splash page route */}
      <Route path="/" element={<SplashPage></SplashPage>} />

      {/* Menu item routes */}
      {menuItems
        .filter((item) => item.include === "true")
        .map((item) => {
          const pageKey = `${navigationData?.layout}-${item?.pageType}`
          const Page = pageIndex[pageKey]
          const Feature = featureIndex[pageDataMap[item?.pageType]?.feature]

          if (!Page) {
            console.warn(`No page component found for key: ${pageKey}`)
            return null
          }
          
          return (
            <Route
            key={item?.pageType}
            path={`/${item?.pageType}`}
            element={
              <Page>
                  {Feature && <Feature {...pageDataMap[item?.pageType]} />}
                </Page>
              }
              />
            );
          })}
          <Route path="/tube" element={<TubeConnections/>} />

      <Route path="*" element={<ErrorScreen error={"Page not found"} />} />
    </Routes>
  )
}
export default PageBuilder
